module.exports = fox._r("fonts/tags-filter.eot", __webpack_public_path__ + "_/_/_/root/fonts/38LfJPg.eot");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/fonts/tags-filter.eot
// module id = 423
// module chunks = 4